import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { fetchCourseById } from "../../../service/courses/curses-by/get-curses-by-id/fetchCourseById";
import {CourseByIdApiResponse} from "../../../types/courses/curses-by/cursesBy";


interface CourseState {
    courseById: CourseByIdApiResponse | null;
    loading: boolean;
    error: string | null;
    errors: {
        [key: string]: string[];
    };
}

const initialState: CourseState = {
    courseById: null,
    loading: false,
    error: null,
    errors: {},
};

const courseByIdSlice = createSlice({
    name: "course",
    initialState,
    reducers: {
        setCourseById: (state, action) => {
            state.courseById = action.payload;
            state.loading = false;
            state.error = null;
        },
        setErrorById: (state, action: PayloadAction<{ success: boolean; error: string; errors: { [key: string]: string[] } }>) => {
            state.error = action.payload.error;
            state.errors = action.payload.errors;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCourseById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCourseById.fulfilled, (state, action) => {
                state.loading = false;
                // @ts-ignore
                state.courseById = action.payload;
            })
            .addCase(fetchCourseById.rejected, (state, action) => {
                state.loading = false;
                // @ts-ignore
                state.error = action.payload;
            });
    },
});

export const { setCourseById,setErrorById } = courseByIdSlice.actions;

export const courseByIdReducer = courseByIdSlice.reducer;
